<template>
  <Card>
    <h1 slot="Title">Army Financial Management & Comptroller</h1>
    <div slot="MainContent">
      <div class="MainContent">
        <figure>
          <img :src="Image" alt="Website Screenshot">
        </figure>
      </div>
    </div>
    <div slot="Notes">
      <p style="line-height:normal;margin-top:4.32pt;margin-bottom:0pt;margin-left:0in;margin-right:0in;text-indent:0in;text-align:left;vertical-align:baseline;"><span style="font-size: 16px; font-family: Calibri; color: rgb(255, 255, 255); font-weight: bold;">Army Financial Management &amp; Comptroller</span></p>
      <p style="line-height:normal;margin-top:4.32pt;margin-bottom:0pt;margin-left:0in;margin-right:0in;text-indent:0in;text-align:left;vertical-align:baseline;"><span style="color: rgb(255, 255, 255);"><span style="font-size: 16px; font-family: Calibri; font-weight: bold;">Note: Have students go to&nbsp;http://www.asafm.army.mil, and&nbsp;add to their favorites on there computer. Briefly discuss/familiarize students with 37-100 and&nbsp;</span><span style="font-size: 16px; font-family: Arial;">Army Management Structure (Federated ERPs) Guide&nbsp;</span><span style="font-size: 16px; font-family: Calibri; font-weight: bold;">content</span><span style="font-size: 16px; font-family: Calibri; font-weight: bold; vertical-align: baseline;">&nbsp;on the website.</span></span></p>
      <p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="color: rgb(255, 255, 255);"><span style="font-size: 16px; font-family: Arial; font-weight: bold;">DFAS-IN Manual 37-100&nbsp;</span><span style="font-size: 16px; font-family: Arial;">The AMS manual:</span></span></p>
      <p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="color: rgb(255, 255, 255);"><span style="font-size: 16px; font-family: Arial;">&nbsp;</span></span></p>
      <p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="color: rgb(255, 255, 255);"><span style="font-size: 16px; font-family: Arial;">(1) &nbsp; Establishes standard codes and terms for classifying financial resource transactions under applicable public law.</span></span></p>
      <p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="color: rgb(255, 255, 255);"><span style="font-size: 16px; font-family: Arial;">(2) &nbsp; Establishes the Standard Army Accounting Classification.&nbsp;</span></span></p>
      <div style="margin-top:0pt;margin-bottom:0pt;margin-left:.25in;text-indent:-.25in;text-align:left;"><span style="color: rgb(255, 255, 255);"><span style="font-size:16px;">(3)</span><span style="font-size: 16px; font-family: Arial;">Establishes the level of detail and frequency for accounting and reporting of financial data.&nbsp;</span></span></div>
      <div style="margin-top:0pt;margin-bottom:0pt;margin-left:.25in;text-indent:-.25in;text-align:left;"><span style="color: rgb(255, 255, 255);"><span style="font-size:16px;">(4)</span><span style="font-size: 16px; font-family: Arial;">(4) &nbsp;Prescribes performance factors for organizations and functions.</span></span></div>
      <div style="line-height:normal;margin-top:4.32pt;margin-bottom:0pt;margin-left:.25in;margin-right:0in;text-indent:-.25in;text-align:left;vertical-align:baseline;"><span style="color: rgb(255, 255, 255);"><span style="font-size:16px;">(5)</span><span style="font-size: 16px; font-family: Arial;">Will be published and updated through electronic message changes and chapter replacement. &nbsp;A fresh baseline will be&nbsp;</span></span><span style="font-size: 16px; font-family: Arial; color: rgb(255, 255, 255);">created annually.</span></div>
    </div>
  </Card>
</template>

<style scoped>
.MainContent {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 100%;
}

figure > img {
  width: 100%;
  height: auto;
}

</style>

<script>
import Card from '../../../components/Card.vue';

export default {

  components: {
    Card
  },
  name: 'ArmyFinancialManagementAndComptroller',
  
  data() {
    return {
      Image: require('@/assets/Army FM & Comptroller.png')
    }
  }
  
}
</script>